import { FormularioAtendimentoList } from '../../../avaliacoes/avaliacoes-pendentes-list/core/_models'

/**
 * Formulários da interconsulta pela flag `interconsulta` do backend: o que o solicitante preenche e
 * o teleconsultor responde e assina (é a mesma instância). Depois de uma réplica há duas instâncias
 * marcadas; a aberta é a não assinada.
 *
 * Sem nenhum marcado (interconsulta antiga cuja configuração mudou, ou empresa sem formulário de IC),
 * devolve todos os não cancelados, para a tela deixar escolher. A flag nunca vem marcada errada,
 * então não há critério reserva por nome nem por assinatura.
 */
export const formulariosDaInterconsulta = (formularios: FormularioAtendimentoList[] = []) => {
  const ativos = formularios.filter((f) => !f.cancelado)
  const marcados = ativos.filter((f) => f.interconsulta)
  return marcados.length > 0 ? marcados : ativos
}

/** Mais recente primeiro: depois de uma réplica há mais de uma instância do formulário. */
export const maisRecentePrimeiro = (a: FormularioAtendimentoList, b: FormularioAtendimentoList) =>
  (b.data ?? '').localeCompare(a.data ?? '') || Number(b.id) - Number(a.id)

/**
 * Formulários a preencher (não assinados), o mais recente primeiro. Com marcado pelo backend é a
 * instância aberta — abrir o primeiro; sem marcado, a lista para escolher.
 */
export const formulariosEmAberto = (formularios: FormularioAtendimentoList[] = []) =>
  formulariosDaInterconsulta(formularios)
    .filter((f) => !f.assinado)
    .sort(maisRecentePrimeiro)

/** Há formulário marcado pelo backend: o primeiro em aberto é o certo, sem perguntar. */
export const temFormularioMarcado = (formularios: FormularioAtendimentoList[] = []) =>
  formularios.some((f) => f.interconsulta && !f.cancelado)

/** O solicitante já preencheu a solicitação (alguma instância respondida). */
export const solicitacaoRespondida = (formularios: FormularioAtendimentoList[] = []) =>
  formulariosDaInterconsulta(formularios).some((f) => f.respondido)

/**
 * Formulários respondidos que aguardam a assinatura do teleconsultor. Aqui vale a assinatura
 * obrigatória (`formulario.assinar`): é o que o backend aceita assinar.
 */
export const pareceresParaAssinar = (formularios: FormularioAtendimentoList[] = []) =>
  formularios.filter((f) => f.formulario?.assinar && f.respondido && !f.concluido && !f.cancelado)
